var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBybitWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 48,
    viewBox: "0 0 123 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_411_1299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.5405 35.7985V4.23535H93.8849V35.7985H87.5405Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.601 45.1742H0V13.6111H13.0541C19.3985 13.6111 23.0952 17.0688 23.0952 22.4774C23.0952 25.9784 20.721 28.2409 19.0777 28.9942C21.0392 29.8804 23.5501 31.8748 23.5501 36.0882C23.5501 41.9822 19.3985 45.1742 13.601 45.1742ZM12.5519 19.109H6.34433V26.3792H12.5519C15.2444 26.3792 16.7509 24.9161 16.7509 22.7429C16.7509 20.5722 15.2444 19.109 12.5519 19.109ZM12.9621 31.9207H6.34433V39.6786H12.9621C15.8384 39.6786 17.2057 37.9064 17.2057 35.7768C17.2057 33.6495 15.8359 31.9207 12.9621 31.9207Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9011 32.2297V45.1742H36.6016V32.2297L26.834 13.6111H33.7252L39.7961 26.3333L45.7751 13.6111H52.6663L42.9011 32.2297Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6528 45.1742H57.0518V13.6111H70.1059C76.4503 13.6111 80.147 17.0688 80.147 22.4774C80.147 25.9784 77.7728 28.2409 76.1295 28.9942C78.091 29.8804 80.602 31.8748 80.602 36.0882C80.602 41.9822 76.4503 45.1742 70.6528 45.1742ZM69.6038 19.109H63.3961V26.3792H69.6038C72.2961 26.3792 73.8026 24.9161 73.8026 22.7429C73.8026 20.5722 72.2961 19.109 69.6038 19.109ZM70.0139 31.9207H63.3961V39.6786H70.0139C72.8902 39.6786 74.2575 37.9064 74.2575 35.7768C74.2575 33.6495 72.8902 31.9207 70.0139 31.9207Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.333 19.109V45.1766H107.989V19.109H99.499V13.6111H122.823V19.109H114.333Z",
    fill: "#FCFCFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_411_1299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122.824,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBybitWhite);
export default __webpack_public_path__ + "static/media/bybit_white.21e3335696671ff096abdb1bb4e78b0c.svg";
export { ForwardRef as ReactComponent };